import { CountDownTimer, Text } from '@intigral/shared';
import { __ } from '../../../../translations';

export const getReminderText = (rewindDays: number) => {
    if (!rewindDays) return null;

    return (
        <Text as="span" color={rewindDays > 2 ? 'green' : 'red'}>
            {__('ppv_content_available')} {rewindDays} {__(rewindDays > 1 ? 'ppv_days' : 'ppv_day')}
        </Text>
    );
};

export const getTimer = (eventBroadcastTs: number) => {
    return (
        <CountDownTimer
            timeStamp={eventBroadcastTs}
            labelDay={__('timer_days')}
            labelHour={__('timer_hours')}
            labelMinute={__('timer_mins')}
            labelSecond={__('timer_sec')}
        />
    );
};
